/*
ashraf 10/16/2022  2700657555  added code comments in search, add user management.
prakash 26/10/2022 2700657555 added classes for new table UI.
Rohini 30/10/2022 2700657555 Removed the tool bar
akhila 10/31/2022 2700657555 TablePagination bugFix
saikrishna 11/03/2022 2700657555 Changed paginationOptions
Poornima 12/15/2022 2700657555 Integrated reusable delete popup in user management
Prakash 12/22/2022 2700657555 Fixed Table Pagination styling.
suresh peddavoora 03/01/2023 2700657555 New UI changes fixes
Ravi 05/31/2023 2700657555 changed delete popup message
Akhila 06/05/2023 2700657555 unsaved changes bug fixed/implemented
*/

import React, {useEffect} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {tablePageRows, defaultRows} from '../../../constants/ReusableTablePagination';
import GuiTable from '../../../components/FormComponents/GuiTable';
import DeleteTableRecordPopup from '../../../util/DeleteTableRecordPopup';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';

// where the selected roles for that user are shown in a table (2700689074)
export default function RolesTable({
  selectedRows,
  setSelectedRows,
  deletedIds,
  setDeletedIds,
  handleDirty,
}) {
  const [rows, setRows] = React.useState(defaultRows);
  const [isDelete, setIsDelete] = React.useState(false);
  const [deleteData, setDeleteData] = React.useState({});
  const columns = [
    {
      title: 'Role Name',
      field: 'roleName',
      cellStyle: {maxWidth: 500},
      minWidth: '300px',
    },
    {
      title: 'Role Description',
      field: 'roleDescription',
      width: '2%',
      cellStyle: {maxWidth: 500},
      minWidth: '300px',
    },
  ];
  const handleDelete = (rowData) => {
    setDeleteData(rowData);
    setIsDelete(true);
  };
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  const handleSubmit = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const data = [...selectedRows];
        const newData = data.filter((row) => row.roleId !== deleteData?.roleId);
        const newDeletedIds = [...deletedIds];
        if (deleteData?.roleId && deleteData?.key !== 'new') {
          newDeletedIds.push(deleteData?.roleId);
        }
        setDeletedIds(newDeletedIds);
        setSelectedRows(newData);
        setIsDelete(false);
        resolve();
      }, 1000);
      handleDirty(true);
    });
  };
  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleDeleteClose}
        title="Delete Role"
        value={`Are you sure you want to delete the ${deleteData?.roleName} Role?`}
        handleSubmit={handleSubmit}
      />
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={selectedRows}
            textAlign="left"
            options={{
              search: false,
              pageSize: rows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              toolbar: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2"></div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
            actions={[
              (rowData) => {
                return {
                  icon: () => <DeleteOutlined />,
                  tooltip: 'Delete',
                  onClick: (event, rowData) => {
                    handleDelete(rowData);
                  },
                };
              },
            ]}
          />
        </div>
      </Grid>
    </>
  );
}
